import type { LandingExperienceResponse } from './interfaces'
import { MOCK_LANDING_EXPERIENCE_200_RESPONSE } from './mock'

//TODO: will be replaced with API call in TM-1346
export async function fetchLandingExperience(): Promise<LandingExperienceResponse> {
  return MOCK_LANDING_EXPERIENCE_200_RESPONSE
}
